import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import SearchProducts from "./SearchProducts.graphql";
import { productSearch } from "../../modules/api";
import { useBrands } from "../../modules/shared-entities";

export default function useProductSearch(f = undefined) {
    const brands = useBrands();

    const filter = useMemo(
        () => {
            const filter = {};

            if (f?.brands && f.brands.length && brands.data) {
                filter.brands = f
                    .brands
                    .map((id) => brands.data.brands.find((b) => b.id === id))
                    .filter(Boolean)
                    .map((brand) => ({ id: brand.legacyID }));
            }
            if (f?._brands && !f?._brands?.includes?.("*") && brands.data) {
                const _brands = f
                    ._brands
                    .map((id) => brands.data.brands.find((b) => b.id === id))
                    .filter(Boolean)
                    .map((brand) => brand.legacyID);
                if (filter.brands) {
                    filter.brands = filter.brands.filter(
                        ({ id }) => _brands.includes(id)
                    );
                } else {
                    filter.brands = _brands.map((id) => ({ id }));
                }
            }

            if (f?.bimClasses && f.bimClasses.length) {
                filter.bimClasses = f.bimClasses.map((id) => ({ id }));
                if (!f.bimClasses.length) {
                    delete filter.bimClasses;
                }
            }

            if (f?.countries && f.countries.length) {
                filter.countries = f.countries;
                if (!f.countries.length) {
                    delete filter.countries;
                }
            }

            if (f?.token) {
                filter.name = f.token;
            }

            if (f?.archived !== undefined) {
                filter.archived = f.archived;
            }

            return filter;
        },
        [
            f.brands,
            f.archived,
            f.token,
            f.countries,
            f.bimClasses,
            f.brands,
            brands,
        ],
    );

    return useQuery(
        gql(SearchProducts),
        {
            client: productSearch,
            skip: brands.loading,
            variables: {
                discovery: f === undefined,
                filter,
                language: "en",
                page: {
                    first: 50,
                },
            },
        },
    );
}
